module.exports = __webpack_public_path__ + "img/logo_sura.e66dd2d2.png";